import { c as _c } from "react/compiler-runtime";
import styles from "./FullVideo.module.scss";
import type { SanityAsset } from "@sanity/image-url";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Play } from "react-feather";
export const FullVideo: React.FC<{
  video: SanityAsset;
  alt: string;
}> = t0 => {
  const $ = _c(21);
  const {
    video,
    alt
  } = t0;
  const videoPlayerRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  let t1;
  if ($[0] !== playing) {
    t1 = () => {
      if (!playing) {
        videoPlayerRef.current?.play();
        setPlaying(true);
      } else {
        videoPlayerRef.current?.pause();
        setPlaying(false);
      }
    };
    $[0] = playing;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const playPause = t1;
  let t2;
  if ($[2] !== playing) {
    t2 = !playing && <div className={styles.playbuttoninner}><Play size={78} /></div>;
    $[2] = playing;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== playPause || $[5] !== t2) {
    t3 = <div className={styles.playbutton} onClick={playPause}>{t2}</div>;
    $[4] = playPause;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== playing) {
    t4 = <VideoProgress videoPlayerRef={videoPlayerRef} playing={playing} />;
    $[7] = playing;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      (videoPlayerRef.current as any).currentTime = 0;
      setPlaying(false);
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = `${video.url}#t=0.01`;
  let t7;
  if ($[10] !== t6) {
    t7 = <video ref={videoPlayerRef} onEnded={t5} playsInline={true} preload="metadata"><source src={t6} type="video/mp4" /></video>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t7) {
    t8 = <div className={styles.videoWrapper}>{t3}{t4}{t7}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== alt) {
    t9 = <span className="caption">{alt}</span>;
    $[16] = alt;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <div className={styles.wrapper}>{t8}{t9}</div>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
};

/**
 * @param progress A number between 0 and 1
 */
const VideoProgress: React.FC<{
  videoPlayerRef: any;
  playing: boolean;
}> = ({
  videoPlayerRef,
  playing
}) => {
  const [progress, setProgress] = useState(0);
  const [currentFrame, setCurrentFrame] = useState(0);
  useEffect(() => {
    if (playing) setCurrentFrame(requestAnimationFrame(updateProgress));else cancelAnimationFrame(currentFrame);
  }, [playing, setCurrentFrame]);
  const updateProgress = useCallback(() => {
    setProgress(videoPlayerRef.current?.currentTime / videoPlayerRef.current?.duration);
    requestAnimationFrame(updateProgress);
  }, [setProgress, videoPlayerRef]);
  return <div className={styles.videoProgressBar} style={{
    width: `${progress * 100}%`
  }}></div>;
};